import { render, staticRenderFns } from "./dataCentreindex.vue?vue&type=template&id=a0970db4&scoped=true&"
import script from "./dataCentreindex.vue?vue&type=script&lang=js&"
export * from "./dataCentreindex.vue?vue&type=script&lang=js&"
import style0 from "./dataCentreindex.vue?vue&type=style&index=0&id=a0970db4&prod&scoped=true&lang=css&"
import style1 from "./dataCentreindex.vue?vue&type=style&index=1&id=a0970db4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0970db4",
  null
  
)

export default component.exports